import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { FormControl } from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoginDialogComponent } from '../../../dialogs/auth/login-dialog/login-dialog.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-validation-errors',
  standalone: true,
  imports: [LoginDialogComponent],
  templateUrl: './validation-errors.component.html',
  styleUrl: './validation-errors.component.scss'
})
export class ValidationErrorsComponent {
  @Input() control!: FormControl;
  @Input() showKenitalaValidation: boolean;
  @Input() maxlength: number;


  constructor(private dialogService: DialogService, private router: Router
  ){

  }

  containsOnlyDigits(value: string): boolean {
    return /^\d+$/.test(value);
  }


  public openLoginDialog() {
    const dialogRef: DynamicDialogRef= this.dialogService.open(
      LoginDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
        data: {
          checkoutLogin: true,
        },
      }
    );

    dialogRef.onClose.subscribe((result) => {
      if (result) {

      }
    });
  }


}
